export default "__VITE_ASSET__BXiFi9FJ__"